// extracted by mini-css-extract-plugin
module.exports = {"bg":"brand-background_bg__E0qux","svg":"brand-background_svg__1Di1c"};